(function(){
  'use strict';
  document.documentElement.classList.remove('no-js');

  // Mobile drawer
  var drawer = document.querySelector('[data-drawer]');
  function openDrawer(){
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('drawer-open');
    var toggle = document.querySelector('[data-drawer-toggle]');
    if (toggle) toggle.setAttribute('aria-expanded', 'true');
  }
  function closeDrawer(){
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('drawer-open');
    var toggle = document.querySelector('[data-drawer-toggle]');
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
  }
  document.querySelectorAll('[data-drawer-toggle]').forEach(function(b){
    b.addEventListener('click', openDrawer);
  });
  document.querySelectorAll('[data-drawer-close]').forEach(function(b){
    b.addEventListener('click', closeDrawer);
  });
  document.addEventListener('keydown', function(e){
    if (e.key === 'Escape') closeDrawer();
  });

  // FAQ accordion
  document.querySelectorAll('.faq__item').forEach(function(item){
    var btn = item.querySelector('.faq__q');
    if (!btn) return;
    btn.addEventListener('click', function(){
      item.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', item.classList.contains('is-open') ? 'true' : 'false');
    });
  });

  // Product gallery
  var thumbs = document.querySelectorAll('.product__thumb');
  var mainImage = document.querySelector('.product__main-image img');
  thumbs.forEach(function(thumb){
    thumb.addEventListener('click', function(){
      thumbs.forEach(function(t){ t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
      var src = thumb.dataset.full || (thumb.querySelector('img') && thumb.querySelector('img').src);
      if (mainImage && src) {
        mainImage.src = src;
      }
    });
  });

  // Quantity stepper
  document.querySelectorAll('.product__quantity-control').forEach(function(qty){
    var input = qty.querySelector('input');
    var dec = qty.querySelector('[data-qty="dec"]');
    var inc = qty.querySelector('[data-qty="inc"]');
    if (!input) return;
    if (dec) dec.addEventListener('click', function(){
      var v = parseInt(input.value, 10) || 1;
      input.value = Math.max(1, v - 1);
    });
    if (inc) inc.addEventListener('click', function(){
      var v = parseInt(input.value, 10) || 1;
      input.value = v + 1;
    });
  });

  // Sticky cart on product page
  var sticky = document.querySelector('.sticky-cart');
  var addBtn = document.querySelector('[data-product-form-submit]');
  if (sticky && addBtn) {
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        sticky.classList.toggle('is-visible', !e.isIntersecting && window.innerWidth < 1000);
      });
    }, { threshold: 0 });
    io.observe(addBtn);
  }

  // Move Releasit COD Form button (and other product app blocks) into the product form
  function relocateProductAppBlocks(){
    var target = document.querySelector('.product__app-blocks');
    if (!target) return;
    // Cerca app block di Releasit COD Form ovunque nella pagina
    var blocks = document.querySelectorAll('.shopify-app-block.rsi-app-block-container, [id*="releasit_cod_form_button"], #rsi-button-hook');
    blocks.forEach(function(b){
      if (target.contains(b)) return;
      // Se è il hook, sposto il container parent (l'intero blocco)
      var moveNode = b;
      var container = b.closest('.shopify-app-block') || b.closest('.shopify-block');
      if (container && container !== b) moveNode = container;
      target.appendChild(moveNode);
    });
  }
  relocateProductAppBlocks();
  // Riprova dopo un breve delay per app che caricano async
  setTimeout(relocateProductAppBlocks, 300);
  setTimeout(relocateProductAppBlocks, 1000);
  setTimeout(relocateProductAppBlocks, 2500);
  // Observer su mutazioni del DOM (Releasit JS può iniettare DOM in tempi diversi)
  if (window.MutationObserver) {
    var mo = new MutationObserver(function(){ relocateProductAppBlocks(); });
    mo.observe(document.body, { childList: true, subtree: true });
    setTimeout(function(){ mo.disconnect(); }, 8000);
  }

  // Countdown timer (synthetic urgency)
  var cd = document.querySelector('[data-countdown]');
  if (cd) {
    var endTs = parseInt(cd.dataset.countdown, 10);
    if (!endTs || endTs < Date.now()) {
      endTs = Date.now() + 1000 * 60 * 60 * 12; // 12h
    }
    function pad(n){ return n < 10 ? '0' + n : '' + n; }
    function tick(){
      var diff = endTs - Date.now();
      if (diff < 0) diff = 1000 * 60 * 60 * 12;
      var h = Math.floor(diff / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      cd.textContent = pad(h) + ' : ' + pad(m) + ' : ' + pad(s);
    }
    tick();
    setInterval(tick, 1000);
  }
})();
